import React, { FC } from "react";
import styled from "styled-components";
import SvgX from "./Icons/X";

interface VideoModalProps {
  embedURL: string;
  close: () => void;
}

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  z-index: 1503;
  overflow-x: hidden;
  overflow-y: auto;
  display: block;
  padding-right: 17px;
  padding-left: 0px;
`;

const Dialog = styled.div`
  position: relative;
  pointer-events: none;
  display: flex;
  align-items: center;
  margin: 1.75rem auto;
  min-height: calc(100% - 3.5rem);
  margin-left: auto;
  margin-right: auto;
  max-width: 70%;
  width: 95%;
  transform: none;
  transition: transform .3s ease-out;
`;

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-clip: padding-box;
  border-radius: .1875rem;
  outline: 0;
  background-color: transparent;
  border: none;
`;

const Body = styled.div`
  padding: 1rem;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
  position: static;
  width: 100%;
  flex: 0 0 auto;
`;

const Frame = styled.iframe`
  background: #000;
  box-shadow: 0 0 .5rem rgba(0, 0, 0, .6);
  display: block;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
`;

const Backdrop = styled.div`
  position: fixed;
  z-index: 1501;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.5);
  // base.css theme file hides all empty elements
  display: block !important;
`;

const IconWrap = styled.div`
  position: absolute;
  top: -32px;
  right: 0;
  cursor: pointer;
`;

const VideoModal: FC<VideoModalProps> = ({ embedURL, close }) => {
  return (
    <>
      <Modal id="videoModal" role="dialog" aria-labelledby="videoModal" aria-hidden="true" onClick={close}>
        <Dialog role="document">
          <Content>
            <Body>
              {/* <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button> */}
              <IconWrap>
                <SvgX fill="#fff" fontSize="16px" />
              </IconWrap>
              <Frame 
                width="100%" 
                height="500" 
                src={`${embedURL}?autoplay=1`} 
                title="YouTube video player" 
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture" 
                allowFullScreen
              ></Frame>
            </Body>
          </Content>
        </Dialog>
      </Modal>
      <Backdrop />
    </>
  );
};

export default VideoModal;